import * as React from "react";
import { Block } from "../Block";
import { expandBorder, expandBorderRadius } from "../utils/styles";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TBlockProps = React.ComponentProps<typeof Block>;
type TCardProps = { selected?: boolean } & TBlockProps;

const Card = (props: TCardProps) => {
  const { selected, ...restProps } = props;
  const [css, $theme] = useStyletron();

  // @ts-ignore also TODO: Add a themedUseStyletron
  const className = css({
    backgroundColor: $theme.colors.backgroundPrimary,
    ...expandBorderRadius($theme.borders.surfaceBorderRadius),
    ...expandBorder("1px", "Width"),
    ...expandBorder("solid", "Style"),
    ...expandBorder($theme.colors.mono400, "Color"),

    ...(selected && {
      ...expandBorder($theme.colors.primary, "Color"),
      boxShadow: `0 0 0 1px ${$theme.colors.primary}, ${$theme.lighting.shadow600}`,
    }),
  });

  return <Block className={className} {...restProps} />;
};

const CardBody = (props: TBlockProps) => (
  <Block
    paddingTop="scale600"
    paddingRight="scale600"
    paddingBottom="scale600"
    paddingLeft="scale600"
    {...props}
  />
);

export { Card, CardBody };
